export default class UnexpectedStockOutflowRepository {
  async create(data) {
    throw new Error('Method not implemented')
  }

  async upload(file) {
    throw new Error('Method not implemented')
  }

  async get(id) {
    throw new Error('Method not implemented')
  }

  async update(id, data) {
    throw new Error('Method not implemented')
  }

  async delete(id) {
    throw new Error('Method not implemented')
  }

  async getDistinctProducts() {
    throw new Error('Method not implemented')
  }

  async findByProduct(idProducto, fechaInicio, fechaFin) {
    throw new Error('Method not implemented')
  }
} 